import 'globalStyles/product.scss';
import ParseTextToHTML from './presenters/ParseTextToHTML'


const FND = (window.FND = window.FND || {});
FND.BUILDS = FND.BUILDS || {};
FND.BUILDS.Product = FND.BUILDS.Product || {};
FND.BUILDS.Product.ParseTextToHTML = ParseTextToHTML;
/**
 * Uncomment the Below and you can use in snippets,
 * name snippet fnd-product-init.liquid
 *
 */

// {% comment %}
// This snippet has all BMS files the product requires. Also it should to be included only once per product.
// {% endcomment %}
//
//
//
// {{ 'fnd.product.bundle.css' | asset_url | stylesheet_tag }}
// <script src="{{ 'fnd.product.bundle.js' | asset_url }}" defer></script>
//
//
// {% comment %} Put your Liquid Theme settings below! {% endcomment %}
// <script id="product-settings-json" type="application/json">
//     {
//     }
// </script>
//
// <script id="product-object-json" type="application/json">
//     {{ product | json }}
// </script>
//
// <script>
//   document.addEventListener("DOMContentLoaded", function() {
//     var product = JSON.parse(document.querySelector('#product-object-json').innerHTML);
//     var settings = JSON.parse(document.querySelector('#product-settings-json').innerHTML);
//     new FND.BUILDS.Product(settings, product);
//   });
// </script>
